import { createApi } from "@reduxjs/toolkit/query/react";
import { rtkBaseQuery } from "../baseQuery";

export const authApi = createApi({
    baseQuery: rtkBaseQuery,
    reducerPath: "authApi",
    tagTypes: ["USER"],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => {
                return {
                    url: "/login/",
                    method: "POST",
                    body: data,
                };
            },
            invalidatesTags: ["USER"],
        }),
        signUp: builder.mutation({
            query: (data) => {
                return {
                    url: "/register/", // changed from /signup/ to /register/
                    method: "POST",
                    body: data,
                };
            },
        }),
        forgotPassword: builder.mutation({
            query: ({ email }) => ({
              url: "/send-reset-email/",
              method: "POST",
              body: { email },
            }),
        }),
        resetPassword: builder.mutation({
            query: ({ uid, token, new_password }) => ({
              url: `/reset-password/${uid}/${token}/`,
              method: "POST",
              body: { new_password },
            }),
          }),
          getUserData: builder.query({
            query: () => ({
                url: "/user/",
                method: "GET",
            }),
            providesTags: ["USER"],
        }),
        getTenantBrand: builder.query({
            query: () => ({
                url: "/tenant/brand/",
                method: "GET",
            }),
        }),
        updateUserData: builder.mutation({
            query: (data) => ({
                url: "/user/update/",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["USER"],
        }),
        updatePassword: builder.mutation({
            query: (data) => ({
                url: "/update-password/",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["USER"],
        }), 
    }),
});

export const {
    useLoginMutation,
    useSignUpMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useGetUserDataQuery,
    useGetTenantBrandQuery,
    useUpdateUserDataMutation,
    useUpdatePasswordMutation,
} = authApi;
